export const DEMO_COURSES = [
    {
        id: 'react-fundamentals',
        cover_image: "https://via.placeholder.com/300x200",
        title: 'React Fundamentals',
        description: 'Master components, hooks, state management and the React mental model from the ground up.',
        category: 'Frontend',
        level: 'Beginner',
        total_lessons: 32,
        completed_lessons: 22,
        last_chapter: 'Chapter 3: React Essentials',
        last_lesson: 'Custom hooks',
        last_chapter_id: 'ch3',
        last_lesson_id: 'ch3-s2-ss3',
        formatted_duration: '6h 20m',
        color: '#FF6B35',
    },
    {
        id: 'js-algorithms',
        cover_image: "https://via.placeholder.com/300x200",
        title: 'JS Algorithms & Data Structures',
        description: 'Tackle sorting, searching, graphs and dynamic programming with clean JavaScript implementations.',
        category: 'Computer Science',
        level: 'Intermediate',
        total_lessons: 48,
        completed_lessons: 12,
        last_chapter: 'Chapter 2: Building Blocks',
        last_lesson: 'Sorting fundamentals',
        last_chapter_id: 'ch2',
        last_lesson_id: 'ch2-s2-ss1',
        formatted_duration: '11h 45m',
        color: '#2c3e50',
    },
    {
        id: 'node-backend',
        cover_image: "https://via.placeholder.com/300x200",
        title: 'Node.js Backend Development',
        description: 'Build production-ready REST APIs with Node, Express, authentication and database integration.',
        category: 'Backend',
        level: 'Intermediate',
        total_lessons: 40,
        completed_lessons: 40,
        last_chapter: 'Chapter 6: Deployment',
        last_lesson: 'CI/CD pipelines',
        last_chapter_id: 'ch6',
        last_lesson_id: 'ch6-s3-ss2',
        formatted_duration: '9h 10m',
        color: '#1D9E75',
    },
    {
        id: 'css-mastery',
        cover_image: "https://via.placeholder.com/300x200",
        title: 'CSS Mastery',
        description: 'From Flexbox and Grid to animations, custom properties, and responsive design patterns.',
        category: 'Frontend',
        level: 'Beginner',
        total_lessons: 28,
        completed_lessons: 5,
        last_chapter: 'Chapter 1: Layouts',
        last_lesson: 'Flexbox deep dive',
        last_chapter_id: 'ch1',
        last_lesson_id: 'ch1-s2-ss1',
        formatted_duration: '5h 30m',
        color: '#534AB7',
    },
    {
        id: 'typescript-pro',
        cover_image: "https://via.placeholder.com/300x200",
        title: 'TypeScript for React Devs',
        description: 'Add type safety to your React apps: generics, utility types, strict mode and real-world patterns.',
        category: 'Frontend',
        level: 'Advanced',
        total_lessons: 36,
        completed_lessons: 0,
        last_chapter: 'Chapter 1: Foundations',
        last_lesson: 'Why TypeScript?',
        last_chapter_id: 'ch1',
        last_lesson_id: 'ch1-s1-ss1',
        formatted_duration: '8h 00m',
        color: '#D85A30',
    },
    {
        id: 'testing-react',
        cover_image: "https://via.placeholder.com/300x200",
        title: 'Testing React Applications',
        description: 'Unit tests, integration tests and end-to-end coverage with Vitest, Testing Library and Playwright.',
        category: 'Quality',
        level: 'Intermediate',
        total_lessons: 24,
        completed_lessons: 8,
        last_chapter: 'Chapter 2: Integration',
        last_lesson: 'Testing user interactions',
        last_chapter_id: 'ch2',
        last_lesson_id: 'ch2-s1-ss2',
        formatted_duration: '4h 50m',
        color: '#BA7517',
    },
];

export const DEMO_COURSE_OUTLINE = [
    {
        id: 'ch1',
        title: 'Chapter 1: Foundations',
        sections: [
            {
                id: 'ch1-s1',
                title: 'Getting Started',
                subsections: [
                    { id: 'ch1-s1-ss1', type: 'lesson', title: 'What is Code Venture?', completed: true },
                    { id: 'ch1-s1-ss2', type: 'lesson', title: 'Setting up your environment', completed: true },
                    { id: 'ch1-s1-ss3', type: 'lesson', title: 'Your first project', completed: false },
                ],
            },
            {
                id: 'ch1-s2',
                title: 'Core Concepts',
                subsections: [
                    { id: 'ch1-s2-ss1', type: 'lesson', title: 'Variables & data types', completed: false },
                    { id: 'ch1-s2-ss2', type: 'quiz',   title: 'Quiz: Variables', completed: false },
                    { id: 'ch1-s2-ss3', type: 'lesson', title: 'Control flow', completed: false },
                    { id: 'ch1-s2-ss4', type: 'lesson', title: 'Functions', completed: false },
                ],
            },
        ],
    },
    {
        id: 'ch2',
        title: 'Chapter 2: Building Blocks',
        sections: [
            {
                id: 'ch2-s1',
                title: 'Data Structures',
                subsections: [
                    { id: 'ch2-s1-ss1', type: 'lesson', title: 'Arrays & lists', completed: false },
                    { id: 'ch2-s1-ss2', type: 'lesson', title: 'Objects & maps', completed: false },
                    { id: 'ch2-s1-ss3', type: 'lesson', title: 'Sets & stacks', completed: false },
                ],
            },
            {
                id: 'ch2-s2',
                title: 'Algorithms',
                subsections: [
                    { id: 'ch2-s2-ss1', type: 'lesson', title: 'Sorting fundamentals', completed: false },
                    { id: 'ch2-s2-ss2', type: 'quiz',   title: 'Quiz: Algorithms', completed: false },
                    { id: 'ch2-s2-ss3', type: 'lesson', title: 'Search techniques', completed: false },
                ],
            },
        ],
    },
    {
        id: 'ch3',
        title: 'Chapter 3: React Essentials',
        sections: [
            {
                id: 'ch3-s1',
                title: 'Components',
                subsections: [
                    { id: 'ch3-s1-ss1', type: 'lesson', title: 'Functional components', completed: false },
                    { id: 'ch3-s1-ss2', type: 'lesson', title: 'Props & state', completed: false },
                    { id: 'ch3-s1-ss3', type: 'lesson', title: 'Component lifecycle', completed: false },
                ],
            },
            {
                id: 'ch3-s2',
                title: 'Hooks',
                subsections: [
                    { id: 'ch3-s2-ss1', type: 'lesson', title: 'useState & useEffect', completed: false },
                    { id: 'ch3-s2-ss2', type: 'lesson', title: 'useContext & useRef', completed: false },
                    { id: 'ch3-s2-ss3', type: 'quiz',   title: 'Quiz: Hooks', completed: false },
                    { id: 'ch3-s2-ss4', type: 'lesson', title: 'Custom hooks', completed: false },
                ],
            },
            {
                id: 'ch3-s3',
                title: 'Styling',
                subsections: [
                    { id: 'ch3-s3-ss1', type: 'lesson', title: 'CSS Modules', completed: false },
                    { id: 'ch3-s3-ss2', type: 'lesson', title: 'Responsive design', completed: false },
                ],
            },
        ],
    },
    {
        id: 'ch4',
        title: 'Chapter 4: Going Further',
        sections: [
            {
                id: 'ch4-s1',
                title: 'APIs & Data',
                subsections: [
                    { id: 'ch4-s1-ss1', type: 'lesson', title: 'Fetch & Axios', completed: false },
                    { id: 'ch4-s1-ss2', type: 'lesson', title: 'REST principles', completed: false },
                    { id: 'ch4-s1-ss3', type: 'lesson', title: 'Error handling', completed: false },
                ],
            },
            {
                id: 'ch4-s2',
                title: 'Deployment',
                subsections: [
                    { id: 'ch4-s2-ss1', type: 'lesson', title: 'Build & optimise', completed: false },
                    { id: 'ch4-s2-ss2', type: 'quiz',   title: 'Quiz: Deployment', completed: false },
                    { id: 'ch4-s2-ss3', type: 'lesson', title: 'Deploying to Vercel', completed: false },
                ],
            },
        ],
    },
];

export const DEMO_COURSE_OUTLINE_FLAT = DEMO_COURSE_OUTLINE.flatMap(chapter =>
    chapter.sections.flatMap(section =>
        section.subsections
    )
);

